// extracted by mini-css-extract-plugin
export default {"modalContent":"modalContent---qrM3v","resetButton":"resetButton---CPdPD"};